import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotRanking from './components/HotRanking';
import NewReleases from './components/NewReleases';
import CreatorZone from './components/CreatorZone';
import { useSEO } from '@/components/base/useSEO';

export default function Home() {
  const jsonLd = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '黄漫天堂',
    description: '最全黄漫资源导航与推荐平台',
    url: 'https://huangman.tt',
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '黄漫天堂',
      url: 'https://huangman.tt',
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://huangman.tt/' },
      ],
    },
  });

  useSEO({
    title: '黄漫天堂 – 最全黄漫资源导航与推荐平台',
    description: '黄漫天堂是专为漫画爱好者打造的一站式内容导航平台，汇聚海量黄漫资源分类推荐、热门作品排行、新作速递与创作者专区。',
    keywords: '黄漫天堂,黄漫天堂最新资源,黄漫天堂作品推荐,黄漫天堂热门排行,黄漫天堂分类导航,黄漫在线阅读,成人漫画平台推荐',
    canonical: 'https://huangman.tt',
    ogType: 'website',
    jsonLd,
  });

  return (
    <main>
      <HeroSection />
      <CategoryGrid />
      <HotRanking />
      <NewReleases />
      <CreatorZone />
    </main>
  );
}